import clickupLogo from "@static/img/clickup.png";
import githubLogo from "@static/img/github.png";
import hubspotLogo from "@static/img/hubspot.png";
import jiraLogo from "@static/img/jira-icon.png";
import linearLogo from "@static/img/linear.png";
import salesforceLogo from "@static/img/salesforce.png";
import topicflowLogo from "@static/img/topicflow-logo-no-text.svg";
import youtrackLogo from "@static/img/youtrack.svg";

import { classNames } from "@helpers/css";
import { getAssetUrl } from "@helpers/helpers";

import { IntegrationLogoType } from "./integration-logo-helpers";

const IntegrationLogo = ({
  type,
  size = 4,
  className = "",
}: {
  type?: IntegrationLogoType;
  size?: number;
  className?: string;
}) => {
  const lcType = String(type || "").toLowerCase();

  return lcType === String(IntegrationLogoType.Github).toLowerCase() ? (
    <img
      src={getAssetUrl(githubLogo)}
      alt="GitHub"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : lcType === String(IntegrationLogoType.Jira).toLowerCase() ? (
    <img
      src={getAssetUrl(jiraLogo)}
      alt="Jira"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : lcType === String(IntegrationLogoType.Salesforce).toLowerCase() ? (
    <img
      src={getAssetUrl(salesforceLogo)}
      alt="Salesforce"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : lcType === String(IntegrationLogoType.Topicflow).toLowerCase() ? (
    <img
      src={getAssetUrl(topicflowLogo)}
      alt="Topicflow"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : lcType === String(IntegrationLogoType.Clickup).toLowerCase() ? (
    <img
      src={getAssetUrl(clickupLogo)}
      alt="Clickup"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : lcType === String(IntegrationLogoType.Hubspot).toLowerCase() ? (
    <img
      src={getAssetUrl(hubspotLogo)}
      alt="Hubspot"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : lcType === String(IntegrationLogoType.Linear).toLowerCase() ? (
    <img
      src={getAssetUrl(linearLogo)}
      alt="Linear"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : lcType === String(IntegrationLogoType.YouTrack).toLowerCase() ? (
    <img
      src={getAssetUrl(youtrackLogo)}
      alt="YouTrack"
      className={classNames(`h-${size} w-${size} shrink-0`, className)}
    />
  ) : null;
};

export default IntegrationLogo;
